import React, { FC } from 'react'
import ContentRow from './ContentRow'
import LoadingBox from '@src/components/LoadingBox'
import { times } from 'lodash'

const ContentLoadingSkeleton: FC<{ numberOfRecentItems: any }> = ({
  numberOfRecentItems,
}) => (
  <>
    {times(numberOfRecentItems, (i) => (
      <ContentRow
        key={i}
        loading
        firstColumn={
          <LoadingBox height={24} marginBottom={1} marginRight={2} />
        }
        secondColumn={<LoadingBox height={24} />}
      />
    ))}
  </>
)

export default ContentLoadingSkeleton
